/** Shared window math for insight heatmaps when the detail date range changes. */

const MS_PER_DAY = 24 * 60 * 60 * 1000;
const MS_PER_WEEK = 7 * MS_PER_DAY;

const snapToUtcMonday = (date: Date): Date => {
    const utcMidnight = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    const day = utcMidnight.getUTCDay();
    const daysFromMonday = day === 0 ? 6 : day - 1;
    utcMidnight.setUTCDate(utcMidnight.getUTCDate() - daysFromMonday);
    return utcMidnight;
};

const toUtcMidnight = (date: Date): Date => new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));

/** Week columns needed to cover [after, before], aligned to Monday UTC. */
export const weekdayHeatmapWindow = (after: string, before: string): { rangeStart: string; weekCount: number } => {
    const start = snapToUtcMonday(new Date(after));
    const end = new Date(before);
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) {
        return { rangeStart: after, weekCount: 1 };
    }
    const weekCount = Math.max(1, Math.ceil((end.getTime() - start.getTime()) / MS_PER_WEEK));
    return { rangeStart: start.toISOString(), weekCount };
};

/** Day rows needed to cover [after, before] for hour×day heatmaps (UTC midnights, inclusive). */
export const hourDayHeatmapWindow = (after: string, before: string): { rangeStart: string; dayCount: number } => {
    const start = toUtcMidnight(new Date(after));
    const end = toUtcMidnight(new Date(before));
    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) {
        return { rangeStart: after, dayCount: 1 };
    }
    const dayCount = Math.max(1, Math.floor((end.getTime() - start.getTime()) / MS_PER_DAY) + 1);
    return { rangeStart: start.toISOString(), dayCount };
};
